import React, { createContext, useContext } from "react";
import useBinanceTicker, { STREAMED_COINS } from "../hooks/useBinanceTicker";

const CryptoStreamContext = createContext({ prices: {}, status: "connecting" });

export const CryptoStreamProvider = ({ children }) => {
  const value = useBinanceTicker();
  return (
    <CryptoStreamContext.Provider value={value}>
      {children}
    </CryptoStreamContext.Provider>
  );
};

export const useCryptoStream = () => useContext(CryptoStreamContext);
export { STREAMED_COINS };
